var map = {
	"./Android_Female_Happy_Talk_.png": "c244",
	"./Android_Female_Happy_idle_.png": "b29f",
	"./Android_Female_idle.png": "a439",
	"./Android_Female_talking.png": "928a",
	"./Android_Male_Happy_idle_.png": "5e22",
	"./Android_Male_Happy_talk_.png": "aa63",
	"./Android_man_avatar_idle_.png": "3676",
	"./Android_man_avatar_talk_.png": "05d2",
	"./JP_MAN_IDLE.png": "ce11",
	"./JP_MAN_TALKING.png": "c4db",
	"./JP_WOMAN_IDLE.png": "ba18",
	"./JP_WOMAN_TALKING.png": "1c31"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "48e9";